import { api } from '../config/api';

/**
 * 프로모션 만료 처리 서비스
 * 사용자의 활성 프로모션을 확인하고 만료된 프로모션을 처리합니다.
 */

export interface PromotionStatus {
  hasActivePromotion: boolean;
  hasExpiredPromotion: boolean;
  currentPromotion?: {
    promotion_type: string;
    remaining_days: number;
    is_expired: boolean;
    end_date: string;
  };
}

/**
 * 프로모션 상태를 확인하고 만료된 프로모션이 있으면 처리합니다.
 * @returns 프로모션 상태 정보
 */
export const checkAndProcessExpiredPromotions = async (): Promise<PromotionStatus> => {
  try {
    console.log('[PromotionService] 프로모션 만료 체크 시작');
    
    // 1. 프로모션 상태 조회
    const promotionResponse = await api.getPromotionStatusAsync();

    if (promotionResponse?.status === 200 && promotionResponse.data?.code === 1) {
      const promotionData = promotionResponse.data;
      const currentPromotion = promotionData.data?.current_promotion;

      console.log('[PromotionService] 프로모션 상태 조회 성공:', currentPromotion);

      // 2. 만료 체크
      if (currentPromotion && currentPromotion.has_promotion) {
        if (currentPromotion.is_expired) {
          // 3. 만료된 프로모션 발견
          console.log('[PromotionService] 만료된 프로모션 발견:', {
            promotion_type: currentPromotion.promotion_type,
            end_date: currentPromotion.end_date,
            remaining_days: currentPromotion.remaining_days
          });

          // TODO: 백엔드에 만료 처리 API 호출
          // await processExpiredPromotion(currentPromotion.promotion_type);

          return {
            hasActivePromotion: false,
            hasExpiredPromotion: true,
            currentPromotion: {
              promotion_type: currentPromotion.promotion_type,
              remaining_days: currentPromotion.remaining_days,
              is_expired: currentPromotion.is_expired,
              end_date: currentPromotion.end_date
            }
          };
        } else {
          // 4. 활성 프로모션 존재
          console.log('[PromotionService] 활성 프로모션 존재:', currentPromotion.promotion_type);
          
          return {
            hasActivePromotion: true,
            hasExpiredPromotion: false,
            currentPromotion: {
              promotion_type: currentPromotion.promotion_type,
              remaining_days: currentPromotion.remaining_days,
              is_expired: currentPromotion.is_expired,
              end_date: currentPromotion.end_date
            }
          };
        }
      } else {
        // 5. 프로모션 없음
        console.log('[PromotionService] 활성 프로모션 없음');
        
        return {
          hasActivePromotion: false,
          hasExpiredPromotion: false
        };
      }
    } else {
      console.error('[PromotionService] 프로모션 상태 조회 실패');
      
      return {
        hasActivePromotion: false,
        hasExpiredPromotion: false
      };
    }
  } catch (error) {
    console.error('[PromotionService] 프로모션 만료 체크 오류:', error);
    
    return {
      hasActivePromotion: false,
      hasExpiredPromotion: false
    };
  }
};

/**
 * 만료된 프로모션을 백엔드에서 처리하는 함수
 * TODO: 백엔드 API 구현 후 활성화
 */
// const processExpiredPromotion = async (promotionType: string): Promise<void> => {
//   try {
//     const response = await api.processExpiredPromotionAsync(promotionType);
//     
//     if (response?.status === 200 && response.data?.code === 1) {
//       console.log('[PromotionService] 만료 처리 완료:', promotionType);
//     } else {
//       console.error('[PromotionService] 만료 처리 실패:', response?.data?.message);
//     }
//   } catch (error) {
//     console.error('[PromotionService] 만료 처리 오류:', error);
//   }
// };